function getNavigatorPlatform() {
  if (typeof navigator === "undefined") {
    return "";
  }

  const platform = navigator.userAgentData?.platform;

  if (typeof platform === "string" && platform.trim()) {
    return platform.trim().toLowerCase();
  }

  return String(navigator.userAgent || "").toLowerCase();
}

export function isWindowsBrowser() {
  return getNavigatorPlatform().includes("windows");
}

export function isAppleBrowser() {
  const platform = getNavigatorPlatform();

  return (
    platform.includes("mac") ||
    platform.includes("iphone") ||
    platform.includes("ipad") ||
    platform.includes("ipod")
  );
}
